import { Body, Button, Heading, Icon } from '@assembly-js/design-system';

export const AppErrorFallback = ({ isInternal }: { isInternal: boolean }) => (
  <div className="absolute inset-0 flex items-center justify-center px-8">
    <div className="w-full max-w-[530px]">
      <div className="flex flex-col gap-3">
        <div className="w-10 h-10 bg-secondary-hover rounded-md flex items-center justify-center text-light-gray">
          <Icon className="w-5 h-5" icon="WarningSolid" />
        </div>
        <Heading className="leading-8" size="2xl">
          {isInternal
            ? 'Something went wrong'
            : "We're having trouble loading this page"}
        </Heading>
        <Body className="text-secondary" size="lg">
          {isInternal
            ? "This page couldn't load due to an unexpected error. The app is still running, and your work hasn't been lost."
            : "Something didn't load correctly on our end. Please try refreshing the page, or come back in a moment."}
        </Body>
      </div>
      <Button
        className="mt-5 w-full sm:w-fit"
        size="sm"
        label="Refresh page"
        onClick={() => window.location.reload()}
      />
    </div>
  </div>
);
